import React, { useEffect } from 'react';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Problems } from './components/Problems';
import { BrandReveal } from './components/BrandReveal';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { CountdownSection } from './components/CountdownSection';
import { Pricing } from './components/Pricing';
import { UpsellTeaser } from './components/UpsellTeaser';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-ink" data-id="element-0" data-mp="23w4fq47h1a2f">
      <TopBar data-id="element-1" data-mp="23ut97wmn5o7m" />
      <Hero data-id="element-2" data-mp="23t8g8bfz6dbv" />
      <main data-id="element-3" data-mp="3ijxpcqos80jw">
        <SocialProof data-id="element-4" data-mp="3ik7eyd5x05p2" />
        <Problems data-id="element-5" data-mp="3ikqwhsrnks2k" />
        <BrandReveal data-id="element-6" data-mp="3ijfwm41bw4gq" />
        <Volumes data-id="element-7" data-mp="3ihv048vgebg8" />
        <Bonuses data-id="element-8" data-mp="3mlj8gtrwtb2j" />
        <CountdownSection data-id="element-9" data-mp="3ml1397n9rmih" />
        <Pricing data-id="element-10" data-mp="3mk868ye44bdj" />
        <UpsellTeaser data-id="element-11" data-mp="3mjq2lgp4euvl" />
        <Testimonials data-id="element-12" data-mp="3mj6lg27aoaim" />
        <Guarantee data-id="element-13" data-mp="3rbrakqf99zft" />
        <Faq data-id="element-14" data-mp="3rdaselgk8ijp" />
        <FinalCta data-id="element-15" data-mp="3rcsy3udgkeef" />
      </main>
      <Footer data-id="element-16" data-mp="3relvej26lm9r" />
    </div>;
}